import React from 'react';

const BranchSync = () => (
    <div style={cardStyle}>
        <h2 style={{color: '#1a2234'}}>🏢 Branch Sync Support</h2>
        <p style={tagStyle}>Status: Under Development</p>
        <p>Showroom Locations: Is module se aap multi-branch stock manage kar saken ge.</p>
        <div style={{marginTop: '20px', color: '#64748b'}}>
            📍 Main Branch: Connected <br />
            📍 Branch 02: Waiting for sync...
        </div>
    </div>
);

const cardStyle = { backgroundColor: 'white', padding: '25px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' };
const tagStyle = { backgroundColor: '#fef3c7', color: '#92400e', padding: '5px 10px', borderRadius: '5px', display: 'inline-block', fontSize: '12px' };

export default BranchSync;